import { useLang } from "@/contexts/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const text = t.marquee.repeat(2);
  return (
    <section
      id="marquee"
      className="relative bg-[#FFC700] border-y border-black/10 overflow-hidden py-5"
      data-testid="marquee-section"
    >
      <div className="flex whitespace-nowrap marquee-track">
        <span className="font-display text-3xl md:text-5xl font-bold uppercase tracking-tighter text-black px-6">
          {text}
        </span>
        <span className="font-display text-3xl md:text-5xl font-bold uppercase tracking-tighter text-black px-6" aria-hidden="true">
          {text}
        </span>
      </div>
    </section>
  );
};

export default Marquee;
